module.exports = __webpack_public_path__ + "static/Black-4f17ac17ca65bd7042053f0332890fea.png";